import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { getZombieInstanceFromPrimaryKey, Ruleset } from '@iotv/datamodel-core';
import { Alert, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getOne } from '../../../data/daoFunctions/daoFunctions';
import { toTitleCase } from '../../../helpers/format';
import { IncidentView } from './IncidentView';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * Wraps an incident view in a thingview compatible shell
 *
 * Also has some convenience stuff like displaying the ruleset if there is one
 */
export const IncidentThingViewWrapper = (props) => {
    const [ruleset, setRuleset] = useState(undefined);
    const [system, setSystem] = useState(undefined);
    const params = useParams();
    const incidentSk = `Incident:${params.id}`;
    useEffect(() => {
        // Find ruleset, if any
        const rulesetRe = /(Ruleset:.+?):/;
        const rulesetSk = rulesetRe.exec(incidentSk)?.[1];
        if (rulesetSk) {
            getOne(getZombieInstanceFromPrimaryKey(rulesetSk)).then((res) => {
                debug && console.log(res);
                if (res.data)
                    setRuleset(new Ruleset(res.data));
            });
        }
        // Extract system ruleset attribute, if any
        const systemRe = /SYSTEM_RULE_VIOLATION:(.+?):/;
        const systemAttribute = systemRe.exec(incidentSk)?.[1];
        if (systemAttribute)
            setSystem(systemAttribute);
    }, [incidentSk]);
    return (_jsxs(Stack, { gap: 1, children: [ruleset && _jsxs(Alert, { severity: "info", children: ["Ruleset: ", ruleset.name] }), system && _jsxs(Alert, { severity: "info", children: ["System ruleset: ", toTitleCase(system)] }), _jsx(IncidentView, { ...props, incidentSk, searchParams: undefined })] }));
};
